export default __webpack_public_path__ + "static/media/icons.350a5ba5.svg";